<nav
  aria-label="Actions"
  class="top-nav"
>
  <ul class="top-menu">
    <li
      (mouseenter)="isViewingBookmarks = true"
      (mouseleave)="isViewingBookmarks = false"
      class="navigation-item"
    >
      <i class="material-icons shortcut-add-bookmark">star_border</i>

      <figure
        *ngIf="isViewingBookmarks"
        class="nested-menu"
      >
        <figcaption i18n="@@common.bookmarks">Bookmarks</figcaption>
        <app-bookmark-side-menu eventName="AddToFavourites"></app-bookmark-side-menu>
      </figure>
    </li>

    <!-- 
        This item is unique since it relies on auxiliary class to maintain the hover effect
        due to the way drag and dropping works in devextreme.
     -->
    <li
      class="navigation-item"
      [class.busy]="isBusyWithTodos"
      (mouseenter)="isBusyWithTodos = true"
      (mouseleave)="handleMouseLeave()"
    >
      <i class="material-icons">done_outline</i>
      <figure class="nested-menu">
        <figcaption i18n="@@common.todoList">To-Do List</figcaption>
        <app-todo-list (draggingInProgress)="isDraggingTodos = $event"></app-todo-list>
      </figure>
    </li>
  </ul>
</nav>

<div
  class="divider"
  aria-hidden="true"
></div>

<nav aria-label="Navigation">
  <ul class="top-menu">
    <li
      *ngFor="let item of navigationItems"
      class="navigation-item"
      routerLinkActive="is-active-link"
    >
      <a
        (click)="clickNavItem(item)"
        [routerLink]="item.State"
      >
        <i class="material-icons accordion-heading">{{ item.Icon }}</i>
      </a>

      <figure
        *ngIf="item.HasChildren && isViewingNavigation"
        class="nested-menu"
      >
        <figcaption>{{ item.Value }}</figcaption>
        <ul>
          <li
            *ngFor="let child of item.Children"
            class="navigation-item"
            routerLinkActive="is-active-link"
          >
            <a
              (click)="clickNavItem(child)"
              [routerLink]="child.State"
            >
              {{ child.Value }}

              <mat-icon *ngIf="child.HasChildren"> keyboard_arrow_right </mat-icon>
            </a>

            <ng-container *ngIf="child.HasChildren">
              <ul class="nested-menu">
                <li
                  *ngFor="let grandChild of child.Children"
                  class="navigation-item"
                  routerLinkActive="is-active-link"
                >
                  <a
                    (click)="clickNavItem(grandChild)"
                    [routerLink]="grandChild.State"
                  >
                    {{ grandChild.Value }}
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </figure>
    </li>
  </ul>
</nav>

<nav
  *ngIf="helpItem"
  class="help-nav"
  [attr.aria-label]="helpItem.Value"
>
  <a
    class="help-link"
    [routerLink]="helpItem.State"
    routerLinkActive="active"
    [title]="helpItem.Value"
    [attr.aria-label]="helpItem.Value"
    (click)="clickNavItem(helpItem)"
  >
    <i class="material-icons" aria-hidden="true">{{ helpItem.Icon }}</i>
  </a>
</nav>

<footer>
  <span
    class="version-info"
    tabindex="0"
    role="img"
    [matTooltip]="versionDisplay.summary"
    matTooltipPosition="right"
    matTooltipClass="version-tooltip"
    [attr.aria-label]="versionDisplay.ariaLabel"
  >
    <span class="version-icon">
      <mat-icon fontSet="material-icons-outlined">info</mat-icon>
      <span
        *ngIf="versionDisplay.environmentName"
        class="environment-dot"
      ></span>
    </span>
  </span>
  <button
    #toggleNavigation
    class="sidebar-toggle"
    (click)="sidebarToggle.emit()"
    [appCollectClickDataAnalytics]="{
      action: 'Expand navigation',
      feature: 'Side Navigation',
      type: 'Toggle Navigation'
    }"
  >
    <mat-icon> keyboard_double_arrow_right </mat-icon>
  </button>
</footer>
